import { FirebaseError } from "firebase/app";
import isFirebaseError from "./FirebaseError";
import { getFirebaseConfig } from "./firebaseConfig";

// Get Cloud Functions base URL based on environment
const getCloudFunctionsBaseUrl = (): string => {
  const config = getFirebaseConfig();
  const region = "asia-northeast3"; // Firebase Functions region
  
  return `https://${region}-${config.projectId}.cloudfunctions.net`;
};

const sendInquiryEmail = async (to: string, subject: string, text: string, html: string): Promise<string> => {
  try {
      const baseUrl = getCloudFunctionsBaseUrl();
      const response = await fetch(
          `${baseUrl}/sendInquiryEMail`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
          },
            body: JSON.stringify({
              to: to,
              subject: subject,
              text: text,
              html: html,
            }),
          }
        );
      
      const data = await response.json();

      if (!response.ok) {
        const maybeError = data.error;
        // FirebaseError 객체로 throw
        if (isFirebaseError(maybeError)) {
          const firebaseError: FirebaseError = {
            code: maybeError.code,
            name: maybeError.name,
            message: maybeError.message
          };
  
          throw firebaseError;
        }
  
        // 그 외 일반 에러로 처리
        throw new Error(data.message || "Unknown error");
      }

      console.log(data);
      return data.message;
  } catch (error) {
      console.error("[sendInquiryEmail] error: " + error);
      throw error;
  }
}

export { sendInquiryEmail };